(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rl-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(x) { return x < 10 ? '0' + x : '' + x; }
    function tick(el) {
      var end = +el.dataset.rlEnd, out = el.querySelector('[data-rl-offer-cd]');
      function run() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) { el.remove(); return; }
        var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
        out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s % 60);
        setTimeout(run, 1000);
      }
      run();
    }
    function init() { document.querySelectorAll('.rl-offer[data-rl-end]:not([data-on])').forEach(function (el) { el.dataset.on = '1'; tick(el); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-sample-live"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(x) { return x < 10 ? '0' + x : '' + x; }
    function left() {
      var n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((m - n) / 1000));
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    function init(root) {
      if (root.dataset.rlSxOn) return;
      root.dataset.rlSxOn = '1';
      var scope = root.closest('.shopify-section') || document;
      var gallery = scope.querySelector('media-gallery');
      var rib = root.querySelector('[data-rl-rib]');
      var more = root.querySelector('[data-rl-more]');
      if (gallery && rib) {
        // On the photo itself (mobile slideshow viewport / first desktop grid photo), never over the thumbnails.
        var grid = gallery.querySelector('.media-gallery__grid');
        var host = (grid && grid.offsetParent && grid.firstElementChild) || gallery.querySelector('slideshow-container') || gallery;
        host.style.position = 'relative'; host.appendChild(rib);
      }
      // Desktop: extra photos under the gallery. Mobile: at the end of the buy box, so the buy button stays high.
      if (more && window.matchMedia('(max-width: 749px)').matches) { var details = root.parentElement; if (details) details.appendChild(more); }
      else if (gallery && more) gallery.insertAdjacentElement('afterend', more);
      var cd = root.querySelector('[data-rl-cd]');
      if (cd) { cd.textContent = left(); setInterval(function () { cd.textContent = left(); }, 1000); }
      var v = root.querySelector('[data-rl-view]');
      if (v) {
        var n = +v.textContent;
        setInterval(function () { n = Math.max(9, Math.min(41, n + (Math.random() < .5 ? -1 : 1) * Math.ceil(Math.random() * 2))); v.textContent = n; }, 5000);
      }
    }
    function run() { document.querySelectorAll('[data-rl-sx]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-size-guide"] && !Shopify.designMode) return;
  try {
    // Size helper: first size whose chest measure is >= the customer's chest (else the largest).
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-rl-chart-input]');
    if (!input) return;
    const chart = input.closest('[data-rl-chart]');
    const rows = [...chart.querySelectorAll('tr[data-size]')];
    const out = chart.querySelector('[data-rl-chart-out]');
    rows.forEach((r) => r.classList.remove('is-match'));
    const v = Number(input.value);
    if (!v) { out.textContent = 'Escribe tu medida y te marcamos la talla.'; return; }
    const match = rows.find((r) => Number(r.dataset.chest) >= v) || rows[rows.length - 1];
    match.classList.add('is-match');
    out.textContent = `Te recomendamos la talla ${match.dataset.size}`;
  });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-rl-open]');
    if (opener) { document.getElementById(opener.dataset.rlOpen)?.showModal(); return; }
    if (e.target.matches('.rl-size__dialog')) e.target.close(); // click on the backdrop
  });
  } catch(e) { console.error(e); }
})();

})();
